import React from 'react'
import { useTranslation } from 'react-i18next'

import BookTrip from './BookTrip'
import OrderDetails from './OrderDetails'
import s from './Summary.module.scss'

export default function Summary() {
  return (
    <div className={s.summary}>
      <OrderDetails />
      <Disclaimer />
      <BookTrip />
    </div>
  )
}

function Disclaimer() {
  const { t } = useTranslation()

  return <div className={s.disclaimer}>{t('confirmation.summary.disclaimer')}</div>
}
